import type { FC } from 'react';

interface Props {
  className?: string;
}

const FlooringIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="3" rx="1" strokeWidth="2" />
      <rect x="3" y="9" width="18" height="3" rx="1" strokeWidth="2" />
      <rect x="3" y="13" width="18" height="3" rx="1" strokeWidth="2" />
      <rect x="3" y="17" width="18" height="3" rx="1" strokeWidth="2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M7 5v3M11 5v3M15 5v3M19 5v3"
      />
    </svg>
  );
};

export default FlooringIcon;
